import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DocumentPaymentTypes from "const/DocumentPaymentTypes";
import DocumentTypes from "const/DocumentTypes";
import React, { useMemo } from "react";
import Select from "nlib/ui/Select";

const DOCUMENT_TYPES_REDUCED = [
  DocumentTypes.INVOICE,
  DocumentTypes.BILL,
  DocumentTypes.RECEIPT,
  DocumentTypes.SALES_RECEIPT
];

const VALUES = {
  [DocumentTypes.INVOICE]: { [DocumentPaymentTypes.BUY]: DocumentTypes.BILL, [DocumentPaymentTypes.SELL]: DocumentTypes.INVOICE },
  [DocumentTypes.RECEIPT]: { [DocumentPaymentTypes.BUY]: DocumentTypes.RECEIPT },
  [DocumentTypes.SALES_RECEIPT]: { [DocumentPaymentTypes.SELL]: DocumentTypes.SALES_RECEIPT }
};

const DocumentTypeSelect = (props) => {
  const { value, type, paymentType, ...restProps } = props;

  const { uiTexts } = useSelector(getTextsData);

  const options = useMemo(() => {
    return DOCUMENT_TYPES_REDUCED
      .map((item) => ({ value: item, label: uiTexts[item] }));
  }, [uiTexts]);

  return (
    <Select
      {...restProps}
      value={VALUES?.[type]?.[paymentType] || ""}
      placeholder={uiTexts.selectDocumentType}
      options={options} />
  );
};

export default React.memo(DocumentTypeSelect);
